<!--
  El icono de ayuda que va al lado de una etiqueta: la explicación sale en el
  globo de `TooltipLayer` al apuntarlo, en vez de ocupar un renglón debajo del
  campo. El texto también va escondido dentro, para que el lector de pantalla
  lo lea junto a la etiqueta.

  No es un botón: dentro de un `<label>` un botón pasaría a ser el control
  etiquetado y el campo se quedaría sin su nombre.
-->
<script lang="ts">
  import Icon from "../Icon.svelte";

  let { text }: { text: string } = $props();
</script>

<span class="info-tip" data-tip={text}>
  <Icon name="information-circle" size={14} />
  <span class="sr-only">{text}</span>
</span>

<style>
  .info-tip {
    display: inline-flex;
    cursor: help;
    color: var(--text-muted);
    transition: color 0.15s;

    &:hover {
      color: var(--text-primary);
    }
  }
</style>
